import { styled, alpha } from '@mui/system';

export const PillContainer = styled('div')(({ theme }) => ({
  padding: '10px 20px',
  borderRadius: 5,
  backgroundColor: alpha(theme.palette.warning.main, 0.15),
  display: 'flex',
  alignItems: 'center',
}));
